import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconShieldMissed = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 22,
	viewBox: "0 0 21 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M19.1133 4.07031L11.2383 0.789062C11.0332 0.707031 10.7051 0.625 10.5 0.625C10.2539 0.625 9.92578 0.707031 9.7207 0.789062L1.8457 4.07031C1.10742 4.39844 0.65625 5.0957 0.65625 5.875C0.65625 16.457 8.4082 21.625 10.459 21.625C12.5918 21.625 20.3438 16.375 20.3438 5.875C20.3438 5.0957 19.8516 4.39844 19.1133 4.07031ZM13.7812 13.0527C13.9863 13.2578 14.1094 13.5039 14.1094 13.75C14.1094 14.3242 13.6172 14.7344 13.125 14.7344C12.8789 14.7344 12.6328 14.6523 12.4277 14.4473L10.5 12.5195L8.53125 14.4473C8.36719 14.6523 8.12109 14.7344 7.875 14.7344C7.30078 14.7344 6.89062 14.2832 6.89062 13.75C6.89062 13.5039 6.97266 13.2578 7.17773 13.0938L9.10547 11.125L7.17773 9.19727C6.97266 9.0332 6.89062 8.78711 6.89062 8.5C6.89062 8.00781 7.30078 7.51562 7.875 7.51562C8.12109 7.51562 8.36719 7.63867 8.53125 7.84375L10.5 9.77148L12.4277 7.84375C12.5918 7.63867 12.8379 7.51562 13.125 7.51562C13.6582 7.51562 14.1094 8.00781 14.1094 8.5C14.1094 8.78711 13.9863 9.0332 13.7812 9.19727L11.8535 11.125L13.7812 13.0527Z",
		fill: "#949494"
	})]
});
const ForwardRef = forwardRef(SvgIconShieldMissed);
export { ForwardRef as ReactComponent };
